import LabServiceCollection from "@/collections/LabServiceCollection";
import ProjectStatusLogModel from "../../models/lab/ProjectStatusLogModel";

/**
 * ProjectStatusLog collection
 */
export default class ProjectStatusLogCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ProjectStatusLogModel;
  }

  /**
   * default collection configuration.
   */
  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddDesc('created_at');
    return CollectionFilter;
  }

}
